import React from 'react';

import { remCss, scssVariables as variables } from 'src/helpers';

const SugarBloodLevelIcon = React.memo(
  ({
    width = 28.796,
    height = 32,
    fill = variables['colors-mc-primary'],
    viewBox = '0 0 28.796 32'
  }) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={remCss(width)}
      height={remCss(height)}
      viewBox={viewBox}
    >
      <g id='sugar-blood-level' transform='translate(-25.628)'>
        <g id='Group_3051' data-name='Group 3051' transform='translate(25.628)'>
          <path
            id='Path_10695'
            data-name='Path 10695'
            d='M394.059,143.46a1.7,1.7,0,1,0,1.7,1.7A1.707,1.707,0,0,0,394.059,143.46Zm0,2.472a.767.767,0,1,1,.766-.768A.769.769,0,0,1,394.059,145.932Z'
            transform='translate(-369.433 -134.494)'
            fill={fill}
          />
          <path
            id='Path_10696'
            data-name='Path 10696'
            d='M318.268,143.46a1.7,1.7,0,1,0,1.7,1.7A1.707,1.707,0,0,0,318.268,143.46Zm0,2.472a.767.767,0,1,1,.766-.768A.769.769,0,0,1,318.268,145.932Z'
            transform='translate(-298.379 -134.494)'
            fill={fill}
          />
          <path
            id='Path_10697'
            data-name='Path 10697'
            d='M323.922,39.439h-6.574a.788.788,0,0,0-.787.787v3.145a.788.788,0,0,0,.787.787h2.268a.469.469,0,0,0,0-.937H317.5V40.376h6.271v2.844H321.9a.469.469,0,0,0,0,.938h2.026a.787.787,0,0,0,.785-.787V40.226A.787.787,0,0,0,323.922,39.439Z'
            transform='translate(-298.378 -36.974)'
            fill={fill}
          />
          <path
            id='Path_10698'
            data-name='Path 10698'
            d='M51.6,0H44.17a2.829,2.829,0,0,0-2.826,2.826v8.952a4.8,4.8,0,0,0,4.774,4.793v2.476H39.611a4.619,4.619,0,0,0,.076-2.646A4.374,4.374,0,0,0,38.128,14a1.557,1.557,0,0,0-1.546-.2,1.574,1.574,0,0,0-.88,1.349,4.06,4.06,0,0,1-1.42,3.138,5.808,5.808,0,0,1-2.458.753H30.549v-.2a.67.67,0,0,0-.669-.671H26.3a.671.671,0,0,0-.671.671V23.39a.469.469,0,1,0,.938,0V19.112h3.046V30.08H26.566V25.55a.469.469,0,1,0-.938,0v4.8a.671.671,0,0,0,.671.671H29.88a.67.67,0,0,0,.669-.671v-.2h.995a2.543,2.543,0,0,1,1.728.718A4.729,4.729,0,0,0,35.885,32l.05,0H44.28a2.026,2.026,0,0,0,1.533-.617,1.963,1.963,0,0,0,.524-1.353,2,2,0,0,0-.4-1.213,1.931,1.931,0,0,0,1.143-1.791,2,2,0,0,0-.405-1.214,1.9,1.9,0,0,0,.62-.436,1.963,1.963,0,0,0,.524-1.353,2.019,2.019,0,0,0-.283-1.033h1.931a1.97,1.97,0,0,0,.189-3.935V16.571a4.8,4.8,0,0,0,4.772-4.793V2.826A2.829,2.829,0,0,0,51.6,0ZM48.715,19.159a.829.829,0,0,1-1.658,0v-4.9h1.658ZM45.13,30.741a1.13,1.13,0,0,1-.85.322H40.313a1.045,1.045,0,0,1-.85-1.744,1.13,1.13,0,0,1,.85-.322H44.28a1.045,1.045,0,0,1,.85,1.744Zm-.112-2.681H40.313a1.047,1.047,0,0,1-.851-1.746,1.13,1.13,0,0,1,.851-.322h4.705a1.037,1.037,0,1,1,0,2.067Zm1.859-4.037a1.02,1.02,0,0,1-1.12,1.033H40.313a1.046,1.046,0,0,1-.851-1.744,1.131,1.131,0,0,1,.851-.322h5.445A1.02,1.02,0,0,1,46.877,24.022Zm3.705-3a1.02,1.02,0,0,1-1.12,1.034h-9.15a1.98,1.98,0,0,0-1.378,3.472,2,2,0,0,0,0,3.005,1.87,1.87,0,0,0-.156.147,1.963,1.963,0,0,0-.524,1.353,2.019,2.019,0,0,0,.283,1.033H35.961a3.777,3.777,0,0,1-2.118-.942,3.416,3.416,0,0,0-2.3-.913h-.995V19.985h1.318a6.91,6.91,0,0,0,2.95-.921,4.911,4.911,0,0,0,1.818-3.816.676.676,0,0,1,.33-.585.628.628,0,0,1,.609.1,3.7,3.7,0,0,1,.915,4.543.469.469,0,0,0,.417.683h7.418a1.766,1.766,0,0,0,3.122,0h.016a1.02,1.02,0,0,1,1.12,1.034Zm2.9-9.241a3.86,3.86,0,0,1-3.835,3.855v-1.55a.763.763,0,0,0-.762-.763H46.88a.762.762,0,0,0-.761.763v1.55a3.86,3.86,0,0,1-3.837-3.856V2.826A1.89,1.89,0,0,1,44.17.938H51.6a1.89,1.89,0,0,1,1.888,1.888v8.952Z'
            transform='translate(-25.628)'
            fill={fill}
          />
        </g>
      </g>
    </svg>
  )
);
SugarBloodLevelIcon.displayName = 'SugarBloodLevelIcon';

export default SugarBloodLevelIcon;
